import type { Psbt } from 'bitcoinjs-lib';

import { InvalidPsbtError } from '../../../errors/InvalidPsbtError';
import { getSigHashType } from '../../getSigHashType';

type ValidateSigHashParams = {
  allowedSigHashTypes: number[];
  input: Psbt['data']['inputs'][0];
};

export const validateSigHash = ({
  allowedSigHashTypes,
  input,
}: ValidateSigHashParams) => {
  const sigHashType = getSigHashType({ input });

  // if the request has allowedSigHashTypes, then we need to make sure that the sigHashType
  // is a member of that array before continuing
  if (
    allowedSigHashTypes?.length &&
    !allowedSigHashTypes.includes(sigHashType)
  ) {
    throw new InvalidPsbtError(
      `sigHashType ${sigHashType} not in allowed list`
    );
  }
};
